import CryptoJS from 'crypto-js';

const keyStr = process.env.VUE_APP_Aeskey;

// Encrypt
/**
*  var word = 18;
*   var key = 'd8cg8gVakEq9Agup'
*   result x6iDoHcQFw6qu+8LHJf1IQ==
* @param {*等待加密的字符串} word
*/

// 16进制转字符串
const getKey = (str) => {
    return str.split(',').map(s => String.fromCharCode(parseInt(s, 16))).join('');
};

/**
* 安全临时方案；用16进制字符串数字混淆处理加密关键字
* //getKey("41,45,53") => AES
* //getKey("45,43,42") => ECB
* //getKey("50,6b,63,73,37") => Pkcs7
*/

const key = CryptoJS.enc.Utf8.parse(getKey(keyStr));
const aes = getKey('41,45,53');
const ecb = getKey('45,43,42');
const kcs = getKey('50,6b,63,73,37');

const encrypt = (word) => {
    if (!word) return word;

    const str = CryptoJS.enc.Utf8.parse(word);
    const encrypted = CryptoJS[aes].encrypt(str, key, {
        mode: CryptoJS.mode[ecb],
        padding: CryptoJS.pad[kcs]
    });
    return encrypted.toString();
};

const decrypt = (encrypted) => {
    const decryptedData = CryptoJS[aes].decrypt(encrypted, key, {
        mode: CryptoJS.mode[ecb],
        padding: CryptoJS.pad[kcs]
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
};

export {
    encrypt,
    decrypt
};
